export default __webpack_public_path__ + "static/media/Discharge Enable.9f2df3e1.png";